import type { EnumDef } from '../types/model';
import { createId } from '../utils/modelUtils';

type EnumEditorProps = {
  enumDef: EnumDef | null;
  onUpdateEnum: (enumId: string, updater: (entry: EnumDef) => EnumDef) => void;
  onDeleteEnum: (enumId: string) => void;
  onDeleteValue: (enumId: string, valueId: string) => void;
};

export const EnumEditor = ({ enumDef, onUpdateEnum, onDeleteEnum, onDeleteValue }: EnumEditorProps) => {
  if (!enumDef) {
    return null;
  }

  return (
    <section className="panel editor">
      <div className="panel-header">
        <div className="panel-title">Enum Editor</div>
        <div className="header-actions">
          <button type="button" className="button ghost" onClick={() => onDeleteEnum(enumDef.id)}>
            Delete Enum
          </button>
        </div>
      </div>
      <div className="editor-grid">
        <div className="field-column">
          <label className="label">Name</label>
          <input
            className="input"
            type="text"
            value={enumDef.name}
            onChange={(event) => onUpdateEnum(enumDef.id, (entry) => ({ ...entry, name: event.target.value }))}
            placeholder="e.g. OrderStatus"
          />
        </div>
        <div className="field-column full">
          <label className="label">Description</label>
          <textarea
            className="input"
            rows={3}
            value={enumDef.description}
            onChange={(event) =>
              onUpdateEnum(enumDef.id, (entry) => ({ ...entry, description: event.target.value }))
            }
            placeholder="Optional"
          />
        </div>
      </div>
      <div className="fields-header">
        <h3>Values</h3>
        <button
          type="button"
          className="button primary"
          onClick={() =>
            onUpdateEnum(enumDef.id, (entry) => ({
              ...entry,
              values: [...entry.values, { id: createId(), label: '' }],
            }))
          }
        >
          Add value
        </button>
      </div>
      <div className="enum-values">
        {enumDef.values.map((value) => (
          <div key={value.id} className="enum-row">
            <input
              className="input"
              type="text"
              value={value.label}
              onChange={(event) =>
                onUpdateEnum(enumDef.id, (entry) => ({
                  ...entry,
                  values: entry.values.map((item) => (item.id === value.id ? { ...item, label: event.target.value } : item)),
                }))
              }
              placeholder="Label"
            />
            <div className="enum-meta">id: {value.id}</div>
            <button type="button" className="button danger" onClick={() => onDeleteValue(enumDef.id, value.id)}>
              Remove
            </button>
          </div>
        ))}
        {enumDef.values.length === 0 && <div className="muted">Add at least one value.</div>}
      </div>
    </section>
  );
};
